var _rect, _g, _g2, _g3, _rect2, _rect3, _g4, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicAdvantageTeaser03Big(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 558 358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 432,
    height: 358,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 358,
    fill: "#fff",
    rx: 28
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.423,
    cy: 157.472,
    r: 414.648,
    fill: "url(#b)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 283,
    x: 109,
    y: 22,
    fill: "#fff",
    rx: 8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillOpacity: 0.4,
    d: "M475 54H223c-6.351 0-11.5-5.149-11.5-11.5V41c0-6.627-5.373-12-12-12H133c-6.627 0-12 5.373-12 12v7a6 6 0 0 1-6 6 3 3 0 0 0-3 3v231.516c0 6.621 5.363 11.991 11.984 12l351 .468c6.634.009 12.016-5.366 12.016-12V66c0-6.627-5.373-12-12-12Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 16,
    x: 125,
    y: 33,
    fill: "#fff",
    rx: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 196,
    y: 38,
    fill: "#EAEAEA",
    rx: 3
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 477,
    height: 19,
    x: 61,
    y: 296,
    fill: "#fff",
    rx: 8
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 20,
    x: 125,
    y: 144,
    fill: "#fff",
    rx: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 20,
    x: 125,
    y: 215,
    fill: "#fff",
    rx: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 7,
    x: 125,
    y: 170,
    fill: "#fff",
    rx: 3.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 7,
    x: 125,
    y: 181,
    fill: "#fff",
    rx: 3.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 7,
    x: 125,
    y: 192,
    fill: "#fff",
    rx: 3.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 20,
    x: 125,
    y: 73,
    fill: "#fff",
    rx: 10
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 7,
    x: 125,
    y: 99,
    fill: "#fff",
    rx: 3.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 7,
    x: 125,
    y: 110,
    fill: "#fff",
    rx: 3.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 7,
    x: 125,
    y: 121,
    fill: "#fff",
    rx: 3.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 7,
    x: 125,
    y: 241,
    fill: "#fff",
    rx: 3.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 7,
    x: 125,
    y: 252,
    fill: "#fff",
    rx: 3.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 7,
    x: 125,
    y: 263,
    fill: "#fff",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F26",
    d: "M298 53h189v243H298z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 20,
    x: 320,
    y: 73,
    fill: "#fff",
    opacity: 0.1,
    rx: 10
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 20,
    x: 320,
    y: 144,
    fill: "#fff",
    opacity: 0.1,
    rx: 10
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 20,
    x: 320,
    y: 215,
    fill: "#fff",
    opacity: 0.1,
    rx: 10
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 7,
    x: 320,
    y: 170,
    fill: "#fff",
    opacity: 0.1,
    rx: 3.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 7,
    x: 320,
    y: 181,
    fill: "#fff",
    opacity: 0.1,
    rx: 3.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 7,
    x: 320,
    y: 192,
    fill: "#fff",
    opacity: 0.1,
    rx: 3.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 7,
    x: 320,
    y: 99,
    fill: "#fff",
    opacity: 0.1,
    rx: 3.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 7,
    x: 320,
    y: 110,
    fill: "#fff",
    opacity: 0.1,
    rx: 3.5
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 7,
    x: 320,
    y: 121,
    fill: "#fff",
    opacity: 0.1,
    rx: 3.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 7,
    x: 320,
    y: 241,
    fill: "#fff",
    opacity: 0.1,
    rx: 3.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 7,
    x: 320,
    y: 252,
    fill: "#fff",
    opacity: 0.1,
    rx: 3.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 7,
    x: 320,
    y: 263,
    fill: "#fff",
    opacity: 0.1,
    rx: 3.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: 368,
    y: 142,
    fill: "#0A0A1A",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M412.002 175.053a12.003 12.003 0 0 1-14.561 10.608 12.002 12.002 0 0 1-8.675-15.789A12.009 12.009 0 0 1 398.948 162a9.334 9.334 0 0 0 13.054 13.053Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: 166,
    y: 136,
    fill: "#fff",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.001 174.667a6.666 6.666 0 0 0 6.666-6.667 6.666 6.666 0 1 0-13.333 0 6.667 6.667 0 0 0 6.667 6.667ZM198 153.333V156M198 180v2.667M187.627 157.627l1.893 1.893M206.479 176.48l1.893 1.893M183.334 168h2.667M210 168h2.667M187.627 178.373l1.893-1.893M206.479 159.52l1.893-1.893"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 421,
    height: 323,
    x: 89,
    y: 6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 383,
    height: 279.984,
    x: 108,
    y: 25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 517,
    height: 59,
    x: 41,
    y: 280,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 104,
    height: 104,
    x: 348,
    y: 126,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 104,
    height: 104,
    x: 146,
    y: 120,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 377.334,
    x2: -450.996,
    y1: 157.241,
    y2: 288.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B21C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#D885FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 299.5,
    x2: 299.5,
    y1: 29,
    y2: 301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M182 152h32v32h-32z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicAdvantageTeaser03Big);
export default __webpack_public_path__ + "static/media/sonic-advantage-teaser-03-big.7481ec0a7e2078d5cbc3f6fa1642fde5.svg";
export { ForwardRef as ReactComponent };